import * as React from 'react';
import { Tag } from "primereact/tag";
import FileSummary from "./FileSummary";
import { Button } from "primereact/button";
import { useAppDispatch } from "../../store";
import { declineUploadFile, doFileDownload, doFileUpload, fetchUploadHistory } from "../../store/upload";
import { TimePeriodServiceGetResponse, TimePeriodServiceGetUploadFilesResponse } from "../../services/api";
import { TieredMenu } from 'primereact/tieredmenu';
import { MenuItem } from 'primereact/menuitem';

export default function UploadListItem({ file, timePeriod }: { file: TimePeriodServiceGetUploadFilesResponse, timePeriod: TimePeriodServiceGetResponse }) {
  const dispatch = useAppDispatch();
  const popoutMenu = React.useRef<TieredMenu>();
  
  async function applyFileUpload() {
    await doFileUpload({ timePeriodDate: timePeriod.timePeriodDate! });
    dispatch(fetchUploadHistory(timePeriod.timePeriodDate!));
  }

  async function declineFileUpload(uploadId: string) {
    await declineUploadFile(uploadId);
    dispatch(fetchUploadHistory(timePeriod.timePeriodDate!));
  }

  function toggleMenu(e: React.MouseEvent<HTMLButtonElement>) {
    popoutMenu.current?.toggle(e);
  }

  const popoutMenuItems = React.useMemo<MenuItem[]>(() => {
    return [
      ...file.status === "Created" ? [
        {
          label: 'remove',
          icon: 'pi pi-trash',
          command: () => declineFileUpload(file.uploadId!)
        },
        {
          label: 'apply',
          icon: 'pi pi-check-square',
          command: () => applyFileUpload()
        } 
      ] : [],      
      {
        label: 'download',
        icon: 'pi pi-download',
        command: async () => {
          const res = await doFileDownload({
              fileId: file.fileId!,
              fileName: file.fileName!,
            });
          
          if (res && res.link) {
            const downloadLink = document.createElement('a');
            downloadLink.href = res.link;
            downloadLink.download = file.fileName!;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
          }
        }
      } 
    ]
  }, [file]);

  return (
    <div className="flex items-center justify-between gap-4">
        <FileSummary file={file} />

        <div className="flex items-center gap-4">
          {file.status === "Created" && (
            <Tag className="text-sm" rounded severity="warning" icon="pi pi-clock" value="Pending"></Tag>
          )}
          

          {file.status === "Complete" && (
            <Tag className="text-sm" rounded severity="success" icon="pi pi-check-circle" value="Current"></Tag>
          )}

          <div className="relative">
            <Button severity="secondary" icon="pi pi-ellipsis-h" onClick={toggleMenu} />
            <TieredMenu appendTo={"self"} ref={popoutMenu} model={popoutMenuItems} popup pt={{ root: { className: 'right-0 !left-auto' } } } />
          </div>
        </div>
    </div>
  )
}